import BrowseTemplatesChip from "./Stream/BrowseTemplatesChip.en";
import BrowseTopicsChip from "./Stream/BrowseTopicsChip.en";
import CarouselTemplate from "./Stream/CarouselTemplate.en";
import EmptyPrivateStream from "./Stream/EmptyPrivateStream.en";
import IndividualDISCProfile from "./WorkStyles/IndividualDISCProfile.en";
import IndividualDialog from "./WorkStyles/IndividualDialog.en";
import IndividualPersonalDetails from "./WorkStyles/IndividualPersonalDetails.en";
import IndividualTombstonePanel from "./WorkStyles/IndividualTombstonePanel.en";
import IndividualsPanel from "./WorkStyles/IndividualsPanel.en";
import MemberAssessmentRow from "./WorkStyles/MemberAssessmentRow.en";
import NewOneOnOneDialog from "./NewOneOnOneDialog.en";
import NewTeamDialog from "./NewTeamDialog.en";
import NewTeamMemberRow from "./NewTeamMemberRow.en";
import NewTeamMemberRowHeader from "./NewTeamMemberRowHeader.en";
import OneTimeMeetingSchedulePanel from "./Stream/OneTimeMeetingSchedulePanel.en";
import RecurrenceListItem from "./Stream/RecurrenceListItem.en";
import RecurrenceListPanel from "./Stream/RecurrenceListPanel.en";
import RecurrenceListPlaceholder from "./Stream/RecurrenceListPlaceholder.en";
import RecurrenceSchedulePanel from "./Stream/RecurrenceSchedulePanel.en";
import RteStreamInstance from "./Stream/RteStreamInstance.en";
import SharedStreamPlaceholder from "./Stream/SharedStreamPlaceholder.en";
import StreamNavigationCard from "./Stream/StreamNavigationCard.en";
import StreamNavigationSidebar from "./Stream/StreamNavigationSidebar.en";
import StreamNavigationToolbar from "./Stream/StreamNavigationToolbar.en";
import StreamNoteHistoryMenu from "./Stream/StreamNoteHistoryMenu.en";
import StreamToolbar from "./Stream/StreamToolbar.en";
import TeamPanel from "./WorkStyles/TeamPanel.en";
import TemplateBrowserPanel from "./Stream/TemplateBrowserPanel.en";
import TemplateCarousel from "./Stream/TemplateCarousel.en";
import TemplateFormPanel from "./Stream/TemplateFormPanel.en";
import TemplatePreviewPanel from "./Stream/TemplatePreviewPanel.en";
import TitleHeader from "./Stream/TitleHeader.en";
import TopicBrowserPanel from "./Stream/TopicBrowserPanel.en";
import TranscriptionBotAlert from "./Stream/TranscriptionBotAlert.en";
import TranscriptionBotPromptPanel from "./Stream/TranscriptionBotPromptPanel.en";
import TranscriptionBotWizard from "./Stream/TranscriptionBotWizard.en";
import TranscriptionItemizedSummary from "./Stream/TranscriptionItemizedSummary.en";
import TranscriptionPanel from "./Stream/TranscriptionPanel.en";
import TranscriptionSummary from "./Stream/TranscriptionSummary.en";
import TranscriptionUploadAlert from "./Stream/TranscriptionUploadAlert.en";
import TranscriptionUploadPromptPanel from "./Stream/TranscriptionUploadPromptPanel.en";
import providerManager from "./Stream/providerManager.en";

export default {
	BrowseTemplatesChip,
	BrowseTopicsChip,
	CarouselTemplate,
	EmptyPrivateStream,
	IndividualDISCProfile,
	IndividualDialog,
	IndividualPersonalDetails,
	IndividualTombstonePanel,
	IndividualsPanel,
	MemberAssessmentRow,
	NewOneOnOneDialog,
	NewTeamDialog,
	NewTeamMemberRow,
	NewTeamMemberRowHeader,
	OneTimeMeetingSchedulePanel,
	RecurrenceListItem,
	RecurrenceListPanel,
	RecurrenceListPlaceholder,
	RecurrenceSchedulePanel,
	RteStreamInstance,
	SharedStreamPlaceholder,
	StreamNavigationCard,
	StreamNavigationSidebar,
	StreamNavigationToolbar,
	StreamNoteHistoryMenu,
	StreamToolbar,
	TeamPanel,
	TemplateBrowserPanel,
	TemplateCarousel,
	TemplateFormPanel,
	TemplatePreviewPanel,
	TitleHeader,
	TopicBrowserPanel,
	TranscriptionBotAlert,
	TranscriptionBotPromptPanel,
	TranscriptionBotWizard,
	TranscriptionItemizedSummary,
	TranscriptionPanel,
	TranscriptionSummary,
	TranscriptionUploadAlert,
	TranscriptionUploadPromptPanel,
	providerManager,
};
